/**
 * Builds a `tel:` URI for use in `href` (RFC 3966 / HTML practice).
 * Returns null when there are no dialable digits.
 */
export function toTelHref(phone: string | null | undefined): string | null {
  if (phone == null || typeof phone !== 'string') {
    return null;
  }
  const trimmed = phone.trim();
  if (!trimmed) {
    return null;
  }
  const digitsOnly = trimmed.replace(/\D/g, '');
  if (!digitsOnly) {
    return null;
  }
  const international = trimmed.trimStart().startsWith('+');
  const subscriber = international ? `+${digitsOnly}` : digitsOnly;
  return `tel:${subscriber}`;
}
